import {
  useCallback,
  useEffect,
  useState,
  type DependencyList
} from "react";

export function useAsyncResource<T>(
  loader: () => Promise<T>,
  deps: DependencyList = []
): {
  data: T | null;
  loading: boolean;
  error: string | null;
  reload: () => () => void;
} {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const run = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    loader()
      .then(result => {
        if (!cancelled) setData(result);
      })
      .catch(e => {
        if (!cancelled)
          setError(e instanceof Error ? e.message : String(e));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller controls deps array
  }, deps);

  useEffect(() => {
    const cancel = run();
    return () => cancel();
  }, [run]);

  return { data, loading, error, reload: run };
}
